import { render, staticRenderFns } from "./InvitesCodesTable.vue?vue&type=template&id=6a81f4aa&scoped=true"
import script from "./InvitesCodesTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvitesCodesTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvitesCodesTable.vue?vue&type=style&index=0&id=6a81f4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81f4aa",
  null
  
)

export default component.exports